<template>
 
  <v-container class="ma-0 pa-0" fluid>
         
       <div dark color="primary" class="header_gray" style="width:100%; 
;">
    <!-- <v-toolbar-title class="white--text">Go to:</v-toolbar-title>
        <v-menu offset-y>
      <v-btn flat slot="activator">{{show}}</v-btn>
      <v-list>
        <v-list-tile v-if="show!='Artefacts'" v-on:click="sorting=1; show='Artefacts'">
          <v-list-tile-title>Artefacts</v-list-tile-title>
           </v-list-tile>
           <v-list-tile v-if="show!='Categories'" v-on:click="sorting=2, show='Categories'">
          <v-list-tile-title>Categories</v-list-tile-title>
            </v-list-tile>
           <v-list-tile v-if="show!='Groups'" v-on:click="sorting=3, show='Groups'">
          <v-list-tile-title>Groups</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="show!='All'" v-on:click="sorting=0, show='All'">
          <v-list-tile-title>All</v-list-tile-title>
            </v-list-tile>
           
       
      </v-list>
    </v-menu>
    <v-spacer></v-spacer> -->
    

   <v-container class="pt-0 pl-4 pr-4" style="max-width:2500px" >
    <v-layout justify-center row class="pt-2 ml-3 mr-3"  style="width:96%"> 
    
        <!-- <v-expansion-panel  style="box-shadow:none;" >
          <v-expansion-panel-content class="exploreExpansionPanel" style="background-color:transparent; box-shadow:none" >
            <div style="color:white" slot="header"> Filter List</div>

          
            
          </v-expansion-panel-content>
        </v-expansion-panel> -->


        <v-btn flat light @click="filter=!filter"> <v-icon left>filter_list</v-icon> {{gLang[lang].explore.filterList}}<v-icon v-if="!filter" left>arrow_drop_down</v-icon> <v-icon v-else left>arrow_drop_up</v-icon></v-btn>

        
    

      <v-spacer></v-spacer>

    
         <v-menu offset-y>
      <v-btn light flat slot="activator"> <v-icon left>filter_list</v-icon> {{sortText}} <v-icon  left>arrow_drop_down</v-icon></v-btn>
      <v-list>
        <v-list-tile @click="sort(item)" v-for="(item,i) in sortItems" :key="i">
          <v-list-tile-title>{{item.name}}</v-list-tile-title>
           </v-list-tile>
  
           
       
      </v-list>
    </v-menu>
   

    </v-layout>

    <v-layout row>




      <transition name="fade"> 

          <v-layout v-if="filter" transition="fade"  style="background-color:white; max-width:90vw" row wrap class="">
              <v-flex xs12 md6 style="border:1px solid #efefef"> 

          <v-text-field append-icon="search" v-model="term" label="Search..." :placeholder="gLang[lang].layout.search" hide-details  class="searchBar"></v-text-field>
                <v-divider></v-divider>
                <v-btn flat style="color: grey;" @click="cloneResults()" :disabled="methodResultsArtefacts.length == 0"><v-icon>map</v-icon> Show results on Map</v-btn>
                <v-list >

                  <v-list-tile>
        <!-- <v-list-tile v-if="show!='Artefacts'" v-on:click="sorting=1; show='Artefacts'"> -->
          <v-list-tile-action>
              <v-checkbox light v-model="showArtefacts"></v-checkbox>
            </v-list-tile-action>
          <v-list-tile-title> {{gLang[lang].explore.artefacts}}</v-list-tile-title>
           </v-list-tile>

              <v-list-tile>
           <!-- <v-list-tile v-if="show!='Categories'" v-on:click="sorting=2, show='Categories'"> -->
             <v-list-tile-action>
              <v-checkbox light v-model="showCollections"></v-checkbox>
            </v-list-tile-action>
          <v-list-tile-title>{{gLang[lang].explore.collections}}</v-list-tile-title>
            </v-list-tile>



              <v-list-tile>
           <!-- <v-list-tile v-if="show!='Groups'" v-on:click="sorting=3, show='Groups'"> -->
             <v-list-tile-action>
              <v-checkbox light v-model="showGroups"></v-checkbox>
            </v-list-tile-action>
          <v-list-tile-title>{{gLang[lang].explore.groups}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="show!='All'" v-on:click="sorting=0, show='All'">
          <v-list-tile-title>All</v-list-tile-title>
            </v-list-tile>
           
       
      </v-list>
              </v-flex>
              

              <v-flex  xs12 md6  style="border:1px solid #efefef">
                <div class="pa-3" style="border-bottom:1px solid #efefef">
                  <v-layout>
                  <v-flex xs1>
                    <v-icon>date_range</v-icon>
                  </v-flex>
                  <v-flex xs11>
                  <p style="color:grey; font-size:1.4em">{{gLang[lang].explore.byDate}}</p>
                    
                  </v-flex>
                </v-layout>

                  <v-layout style="overflow:hidden" >

                    <v-flex xs1>

                    </v-flex>

                    <v-flex xs4>
      <datetime light style="border-bottom:2px solid #efefef" class=" mr-2" :placeholder="gLang[lang].explore.startDate" color="black" v-model="startDate"  :max-datetime="endDate" ></datetime>
                      
                    </v-flex>
                    <v-flex xs1 offset-xs1>
--
                    </v-flex>
                    <v-flex xs4>
      <datetime light style="border-bottom:2px solid #efefef" class="ml-2 mr-2"  :placeholder="gLang[lang].explore.endDate" color="black" v-model="endDate" :min-datetime="startDate"></datetime>
                      
                    </v-flex>
                  </v-layout>
                </div>

                <!-- <div class="pa-3">
                  <v-layout>
                  <v-flex xs1>
                    <v-icon>label</v-icon>
                  </v-flex>
                  <v-flex xs11>
                  <p class="mb-0" style="color:grey; font-size:1.4em">By Tags</p>
                    
                  </v-flex>
                </v-layout>

                  <v-layout >

                    <v-flex xs1>

                    </v-flex>

                    <v-flex xs10>

                       <v-select
              label="Name of Tags"
              v-bind:items="collections"
              item-text="title"
              item-value="title"
              v-model="tags"
              multiple
              chips
              
         
              persistent-hint
            >
            
            
            
            </v-select>
                        
      
                    </v-flex>
                  </v-layout>
                </div> -->

                

                  
              <!-- </v-flex>

              <v-flex xs12 md4 style="border:1px solid #efefef"> -->
                <div class="pa-3" style="border-bottom:1px solid #efefef">
                  <v-layout>
                  <v-flex xs1>
                    <v-icon>directions</v-icon>
                  </v-flex>
                  <v-flex xs11>
                  <p style="color:grey; font-size:1.4em">{{gLang[lang].explore.byLocation}}</p>
                    
                  </v-flex>
                </v-layout>

                  <v-layout >

                    <v-flex xs1>

                    </v-flex>

                    <v-flex xs10>

                                <gmap-autocomplete 
                   @place_changed="setPlace" v-model="place.name" style="width:100%;">
                              </gmap-autocomplete>

 
                    </v-flex>
                  </v-layout>
                </div>
                
                              <div class="pa-3" style="border-bottom:1px solid #efefef">
                  <v-layout>
                  <v-flex xs1>
                    <v-icon>insert_invitation</v-icon>
                  </v-flex>
                  <v-flex xs11>
                  <p style="color:grey; font-size:1.4em">{{gLang[lang].explore.byCronologicalDate}}By Cronological Date</p>
                    
                  </v-flex>
                </v-layout>

                  <v-layout style="overflow:hidden" >

                    <v-flex xs1>

                    </v-flex>

                    <v-flex xs4>
      <datetime light style="border-bottom:2px solid #efefef" class=" mr-2" :placeholder="gLang[lang].explore.startDate" color="black" v-model="startDateCrono"  :max-datetime="endDateCrono" ></datetime>
                      
                    </v-flex>
                    <v-flex xs1 offset-xs1>
--
                    </v-flex>
                    <v-flex xs4>
      <datetime light style="border-bottom:2px solid #efefef" class="ml-2 mr-2"  :placeholder="gLang[lang].explore.endDate" color="black" v-model="endDateCrono" :min-datetime="startDateCrono"></datetime>
                      
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
        </transition>
    </v-layout>
   </v-container>



            <!-- <v-menu offset-y>
      <v-btn flat slot="activator">Sort by <v-icon>keyboard_arrow_down</v-icon></v-btn>
      <v-list>
        <v-list-tile>
          <v-list-tile-title>Author</v-list-tile-title>
           </v-list-tile>
           <v-list-tile>
          <v-list-tile-title>Reviews</v-list-tile-title>
            </v-list-tile>
           <v-list-tile>
          <v-list-tile-title>Featured</v-list-tile-title>
            </v-list-tile>
           
        </v-list-tile>
      </v-list>
    </v-menu> -->
  </div>


  <div v-if="!showArtefacts && !showCollections & !showGroups">

<!-- <v-card color="grey lighten-4 mt-0 pt-4 pb-4" flat>
<v-toolbar-title class="body-2 grey--text mt-4 ml-4 mb-2"> Latest recomended artefacts</v-toolbar-title>



<web-slider1 :artefacts='artefacts' > 
<div v-for="artefact in artefacts" :key="artefact._id">
  <web-artefact-card :artefact='artefact' ></web-artefact-card>  
</div>
</web-slider1>


    </v-card> -->




<!-- 
<v-card color="white lighten-5 pt-1 pb-5" flat>
<v-toolbar-title class="body-2 grey--text mt-4 ml-4 mb-2"></v-toolbar-title>






<web-slider2 :artefacts='artefacts' > 
<div v-for="artefact in artefacts" :key="artefact._id">
  <web-artefact-card-mini :artefact='artefact' ></web-artefact-card-mini>  
</div>
</web-slider2>



    </v-card> -->





<!-- <v-container fluid class="ma-0 pa-0">

    <v-divider></v-divider>
    <v-card flat class="pt-3 pb-3">
      <web-slider1>
        <web-artefact-card-mini v-for="artefact in artefacts" :key="artefact._id" :artefact='artefact'></web-artefact-card-mini>
      </web-slider1>
    </v-card>
  </v-container> -->


<!-- <v-card color="grey lighten-5 mt-4 pb-4" flat>
<v-toolbar-title class="body-2 grey--text mt-4 ml-4 mb-2"> Latest recomended collections</v-toolbar-title>









<web-slider1 :artefacts='artefacts' > 
<div v-for="collection in collections" :key="collection._id">
  <web-collection-card :collection='collection' :artefacts='artefacts'></web-collection-card>  
</div>
</web-slider1>


    </v-card> -->




<!-- <v-card color="grey lighten-5 mt-4 pb-4" flat>
<v-toolbar-title class="body-2 grey--text mt-4 ml-4 mb-2"> Latest recomended groups</v-toolbar-title>

<web-slider1 > 
            <v-flex xs12 md4 class="exploreGroupInSlider" v-for="group in groups" :key="group._id">

         <web-group-card :group='group' :collections='collections' > </web-group-card>

          </v-flex>
</web-slider1>
    </v-card> -->










  <!-- <v-layout justify-center style="background-color:#FAFAFA" class="mt-4">
    <v-flex xs12 md10 style="border-left: 1px solid #efefef; border-right: 1px solid #efefef;">


       
  <v-container fluid class="ma-0 pa-0" style="background-color:white;">
    <v-toolbar-title class="body-2 grey--text  ml-4 " style="" ><h5 class="mt-3">Today in Artefacts</h5>  </v-toolbar-title>
    <v-divider></v-divider>

   
    <v-card flat class="pt-3 pb-3" style="background-color:#FAFAFA">
      <web-slider1>
        <div v-for="(artefact,i) in popularArtefacts" :key="i" v-if="i<5">
        <web-artefact-card-mini   :artefact='artefact' :height='200'></web-artefact-card-mini>
        </div>
      </web-slider1>


      <v-card-actions class="pt-1 mt-0">
          <v-flex  class="text-xs-right">
          <v-btn to="/artefacts" flat>Show all Artefacts</v-btn>
          </v-flex>
      </v-card-actions>
    </v-card>


  </v-container>

  
  <v-container fluid class="ma-0 pa-0" style="background-color:white;">
    <v-toolbar-title class="body-2 grey--text mt-4 ml-4 " style="" ><h5 class="mt-3">Today in Collections</h5>  </v-toolbar-title>
    <v-divider></v-divider>
    <v-card flat class="pt-3 pb-3" style="background-color:#FAFAFA">
      <web-slider1 ref="slick2">
        <div v-for="(collection,i) in popularCollections" :key="i" v-if="i<5" >
        <web-collection-card  :collection='collection' :artefacts='artefacts'></web-collection-card>
        </div>
      </web-slider1>


       <v-card-actions class="pt-1 mt-0">
          <v-flex  class="text-xs-right">
          <v-btn to="/collections" flat>Show all Collections</v-btn>
          </v-flex>
      </v-card-actions>
    </v-card>
  </v-container>

    
  <v-container fluid class="ma-0 pa-0" style="background-color:white;">
    <v-toolbar-title class="body-2 grey--text mt-4 ml-4 " style="" ><h5 class="mt-3">Today in Groups</h5>  </v-toolbar-title>
    <v-divider></v-divider>
    <v-card flat class="pt-3 pb-3" style="background-color:#FAFAFA">
      <web-slider1 ref="slick3">
        <div v-for="(group,i) in popularGroups" :key="i" v-if="i<5">
        <web-group-card  :group='group' :collections='collections'></web-group-card>
        </div>
      </web-slider1>

      <v-card-actions class="pt-1 mt-0">
          <v-flex  class="text-xs-right">
          <v-btn to="/group-collections" flat>Show all Groups</v-btn>
          </v-flex>
      </v-card-actions>
    </v-card>
    </v-container>
    </v-flex>
  </v-layout> -->


<h3 style="text-align:center;color:#eeeeee" class="mt-5">No results Found</h3>









  </div>


  <div v-if="showArtefacts">
          <v-container fluid class="mt-2 mb-2 pl-2 pr-2 pa-0" style="background-color:white; border:1px solid #efefef">
    <v-toolbar-title class="body-2 grey--text  ml-4 text-md-center" style="" ><h5 class="mt-3">{{gLang[lang].explore.artefacts}}</h5>  </v-toolbar-title>
          </v-container>
    <v-container grid-list-md style="max-width:2000px">
      <v-layout row wrap >
          <v-flex xs12 md4 v-for="artefact in  methodResultsArtefacts" :key="artefact._id">

         <web-artefact-card :artefact='artefact' :height='300'></web-artefact-card>

          </v-flex>
      </v-layout>
  </v-container>
  </div>


  <div v-if="showCollections">
    <v-container fluid class="mt-2 mb-2 pl-2 pr-2 pa-0" style="background-color:white; border:1px solid #efefef">
    <v-toolbar-title class="body-2 grey--text  ml-4 text-md-center" style="" ><h5 class="mt-3">{{gLang[lang].explore.collections}}</h5>  </v-toolbar-title>
          </v-container>
    <v-container grid-list-md style="max-width:2000px">
      <v-layout row wrap >
          <v-flex xs12 md4 v-for="collection in methodResultsCollections" :key="collection._id">

               <web-collection-card :collection='collection' :artefacts='artefacts'></web-collection-card>


          </v-flex>
      </v-layout>
  </v-container>
  </div>


  <div v-if="showGroups">
    <v-container fluid class="mt-2 mb-2 pl-2 pr-2 pa-0" style="background-color:white; border:1px solid #efefef">
    <v-toolbar-title class="body-2 grey--text  ml-4 text-md-center" style="" ><h5 class="mt-3">{{gLang[lang].explore.groups}}</h5>  </v-toolbar-title>
          </v-container>
      <v-container grid-list-md style="max-width:2000px">
      <v-layout row wrap >
          <v-flex xs12 md4 v-for="group in methodResultsGroups" :key="group._id">

         


      <web-group-card :group='group' :collections='collections' > </web-group-card>

          </v-flex>
      </v-layout>
  </v-container>
  </div>




     <web-speed-dial-add v-if="isMod||isContrib"></web-speed-dial-add>

<v-dialog
        v-model="mapDialog"
        :width="deviceWidth"
        transition="dialog-bottom-transition"
        :overlay="false"
        :disabled="methodResultsArtefacts.length==0"
        scrollable
      >
<web-locations-explore v-if="methodResultsArtefacts.length>0" :relatedArtefacts="methodResultsArtefactsClick" ></web-locations-explore>
</v-dialog>
 </v-container>



</template>

<script>
import Vue from "vue";
import { Datetime } from "vue-datetime";


export default {
  components: {
    datetime: Datetime
  },
  data() {
    return {
      cronological:false,
      methodResultsArtefactsClick :"",
      startDateCrono:"",
      endDateCrono:"",
      mapDialog:false,
      term: "",
      index: 0,
      options: {
        ro: {
          keys: ["title.ro", "description.ro","pdfText"]
        },
        en: {
          keys: ["title.en", "description.en","pdfText"]
        },
        sr: {
          keys: ["title.sr", "description.sr","pdfText"]
        }
      },
      sortText:"",
      methodResultsArtefacts: [],
      methodResultsGroups: [],
      methodResultsCollections: [],
      place: {},
      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      startDate: "May 18, 2018",
      endDate: "",
      term: "",
      filter: false,
      tabs: null,
      top: false,
      right: true,
      location: "",
      tags: [],
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      gradient: "to top right, rgba(63,81,181, .7), rgba(25,32,72, .0)",
      show: "All",
      sorting: 0,
      showArtefacts: false,
      showCollections: false,
      showGroups: false,

      selectedDate: {
        start: "",
        end: ""
      }
    };
  },
  created() {
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
    this.$store.dispatch("loadUsers");
  },
  computed: {
    deviceWidth(){
    var w = window
    var d = document
    var e = d.documentElement
    var g = d.getElementsByTagName('body')[0]
    return w.innerWidth || e.clientWidth || g.clientWidth
    },
    sortItems() {
      return [
        { name: this.gLang[this.lang].explore.mostPopular },
        { name: this.gLang[this.lang].explore.newest },
        { name: this.gLang[this.lang].explore.oldest },
        { name: "A-Z" },
        { name: "Z-A" },
        {name:"Cronological"}
      ];
    },
    lang() {
      return this.$store.getters.loadLang;
    },
    condition() {
      return (
        this.methodResultsGroups.length == 0 &&
        this.methodResultsCollections.length == 0 &&
        this.methodResultsArtefacts.length == 0
      );
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    popularArtefacts() {
      return this.$store.getters.loadPopularArtefacts;
    },
    popularCollections() {
      return this.$store.getters.loadPopularCollections;
    },
    popularGroups() {
      return this.$store.getters.loadPopularGroups;
    },
    collections() {
      return this.$store.getters.loadAllCollections;
    },
    artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    groups() {
      return this.$store.getters.loadGroups;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod() {
      return this.$store.getters.isMod;
    },
    isContrib() {
      return this.$store.getters.isContrib;
    }
  },

  methods: {
   getFormattedDate(date) {
  var year = date.getFullYear();

  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;

  var day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;
  
  return month + '/' + day + '/' + year;
},
maxDate(){
  return this.artefacts = this.artefacts.sort(function(a, b) {
          return new Date(a.date) - new Date(b.date);
        })[0].date;
},
    cloneResults(){
      
      this.methodResultsArtefactsClick = JSON.parse(JSON.stringify(this.methodResultsArtefacts)).filter(loc=>loc.location != "" && loc.location.geometry);
      this.mapDialog = true;
    },
    allowedDatesDown: val => val >= this.startDate,
    allowedDatesUp: val => val <= this.endDate,
    check1(string) {
      for (var artefact of this.methodResultsArtefacts)
        if (artefact.collectionId.includes(string)) return true;
      return false;
    },
    check2(string) {
      for (var collection of this.methodResultsCollections)
        if (collection.groups.includes(string)) return true;
      return false;
    },
    sort(item) {
      this.sortText = item.name;
    },
    generalSearch() {
      this.searchByTerm(
        this.term,
        this.artefacts,
        this.options[this.lang],
        "artefacts"
      );
      this.searchByTerm(
        this.term,
        this.collections,
        this.options[this.lang],
        "collections"
      );
      this.searchByTerm(this.term, this.groups, this.options[this.lang], "groups");

    },
    generalFilter() {
      this.methodResultsArtefacts = this.filterDateCrono(
        this.methodResultsArtefacts,
        this.startDateCrono,
        this.endDateCrono
      );
      if(this.sortText == "Cronological") {
      this.methodResultsCollections = this.methodResultsCollections.filter(
          collection => this.check1(collection.title.en)
        );
      this.methodResultsGroups = this.methodResultsGroups.filter(group =>
          this.check2(group.title.en)
        );
        }
      this.methodResultsArtefacts = this.filterDate(
        this.methodResultsArtefacts,
        this.startDate,
        this.endDate
      );
      this.methodResultsGroups = this.filterDate(
        this.methodResultsGroups,
        this.startDate,
        this.endDate
      );
      this.methodResultsCollections = this.filterDate(
        this.methodResultsCollections,
        this.startDate,
        this.endDate
      );
    },
    placeSearch() {

      if (this.place.name != "" && this.place.name != undefined) {
        this.methodResultsArtefacts = this.filterPlace(
          this.methodResultsArtefacts,
          this.place
        );
        this.methodResultsCollections = this.methodResultsCollections.filter(
          collection => this.check1(collection.title)
        );
        this.methodResultsGroups = this.methodResultsGroups.filter(group =>
          this.check2(group.title)
        );
      }
    },
    resetSearch() {
      this.methodResultsArtefacts = this.artefacts.slice(0,20);
      this.methodResultsGroups = this.groups.slice(0,5);
      this.methodResultsCollections = this.collections.slice(0,5);
      this.generalFilter();
      this.placeSearch();
    },
    searchByTerm(term, array, options, result) {
      this.$search(term, array, options).then(results => {
        this.generalFilter();
        this.placeSearch();
        if (result == "artefacts") this.methodResultsArtefacts = results;
        else if (result == "collections")
          this.methodResultsCollections = results;
        else if (result == "groups") this.methodResultsGroups = results;
      });
    },
    filterDate(array, startDate, endDate) {
      if (endDate != "" && startDate != "") {
        return array.filter(
          date =>
            new Date(date.meta.creationDate) >= new Date(startDate) &&
            new Date(date.meta.creationDate) <= new Date(endDate)
        );
      } else if (endDate != "" && startDate == "") {
        return array.filter(
          date => new Date(date.meta.creationDate) <= new Date(endDate)
        );
      } else if (endDate == "" && startDate != "") {
        return array.filter(
          date => new Date(date.meta.creationDate) >= new Date(startDate)
        );
      } else return array;
    },
        filterDateCrono(array, startDate, endDate) {
      if (endDate != "" && startDate != "") {
        return array.filter(
          date =>
            new Date(date.date) >= new Date(startDate) &&
            new Date(date.date) <= new Date(endDate) && date.showDate == true
        );
      } else if (endDate != "" && startDate == "") {
        return array.filter(
          date => new Date(date.date) <= new Date(endDate) && date.showDate == true
        );
      } else if (endDate == "" && startDate != "") {
        return array.filter(
          date => new Date(date.date) >= new Date(startDate) && date.showDate == true
        );
      } else return array;
    },
    filterPlace(array, place) {
      if (place && place.name != "") {
        var slng = parseFloat(place.geometry.location.lng());
        var slat = parseFloat(place.geometry.location.lat());
        return array.filter(place => {
          var lng = parseFloat(place.location.geometry.location.lng);
          var lat = parseFloat(place.location.geometry.location.lat);
          return (
            lng > slng - 3 &&
            lng < slng + 3 &&
            lat > slat - 3 &&
            lat < slat + 3
          );
        });
      } else return array;
    },
    setPlace(place) {
      this.place = place;
    },
    onDateSelected: function(daterange) {
      this.selectedDate = daterange;
    },
    showContent(collection) {
      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.artefacts.length; i++) {
        if (this.artefacts[i].collectionId.indexOf(collection.title) > -1) {
          return true;
        }
      }
      return false;
    },
    showContentGroup(group) {
      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.collections.length; i++) {
        if (this.collections[i].groups.indexOf(group.title) > -1) {
          return true;
        }
      }
      return false;
    },
    minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;
      else
        return (
          str
            .split(" ")
            .slice(0, spaces - 1)
            .join(" ") + "..."
        );
    },
    // moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';

    //     }
    //     else
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }
    //   },

    isLast(idart, coltitle) {
      var j,
        k = [];

      for (j = 0; j < this.artefacts.length; j++)
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1)
          k.push(this.artefacts[j]._id);

      if (k[k.length - 1] == idart) return true;
      else return false;
    }
  },
  mounted() {
    
    this.sortText = this.gLang[this.lang].explore.sortBy;
    document.title = "Explore";
    window.scrollTo(0, 0);
    // this.moveButton(this.isAdmin);
  },
  watch: {
    methodResultsArtefacts: function(newValue, oldValue) {
      
      if (newValue.length != 0) this.showArtefacts = true;
      else this.showArtefacts = false;
    },
    methodResultsGroups: function(newValue, oldValue) {
      if (newValue.length != 0) this.showGroups = true;
      else this.showGroups = false;
    },
    methodResultsCollections: function(newValue, oldValue) {
      if (newValue.length != 0) this.showCollections = true;
      else this.showCollections = false;
    },
    term: function(newValue, oldValue) {
      if (newValue == "") this.resetSearch();
      else {
        this.generalSearch();
      }
    },
    startDateCrono: function(newValue, oldValue) {
      if (this.term == "") this.resetSearch();
      else this.generalSearch();
    },
    endDateCrono: function(newValue, oldValue) {
      if (this.term == "") this.resetSearch();
      else this.generalSearch();
    },
    startDate: function(newValue, oldValue) {
      if (this.term == "") this.resetSearch();
      else this.generalSearch();
    },
    endDate: function(newValue, oldValue) {
      if (this.term == "") this.resetSearch();
      else this.generalSearch();
    },
    place: function(newValue, oldValue) {
      if (this.term == "") this.resetSearch();
      this.placeSearch();
    },
    sortText: function(newValue, oldValue) {
      if (this.term == "") this.resetSearch();
      this.filter = true;
      if (newValue == this.gLang[this.lang].explore.mostPopular) {
        this.artefacts = this.artefacts.sort(function(a, b) {
          return b.visited - a.visited;
        });
        this.collections = this.collections.sort(function(a, b) {
          return b.visited - a.visited;
        });
        this.groups = this.groups.sort(function(a, b) {
          return b.visited - a.visited;
        });
      }

      
      if (newValue == this.gLang[this.lang].explore.newest) {
        this.artefacts = this.artefacts.sort(function(a, b) {
          return new Date(b.meta.creationDate) - new Date(a.meta.creationDate);
        });
        this.collections = this.collections.sort(function(a, b) {
          return new Date(b.meta.creationDate) - new Date(a.meta.creationDate);
        });
        this.groups = this.groups.sort(function(a, b) {
          return new Date(b.meta.creationDate) - new Date(a.meta.creationDate);
        });
      }

    if (newValue == "Cronological") {
        this.artefacts = this.artefacts.sort(function(a, b) {
          return new Date(a.date) - new Date(b.date);
        });
       this.endDateCrono = Date.now();
       this.startDateCrono = this.maxDate();
      }

      if (newValue == this.gLang[this.lang].explore.oldest) {
        this.artefacts = this.artefacts.sort(function(a, b) {
          return new Date(a.meta.creationDate) - new Date(b.meta.creationDate);
        });
        this.collections = this.collections.sort(function(a, b) {
          return new Date(a.meta.creationDate) - new Date(b.meta.creationDate);
        });
        this.groups = this.groups.sort(function(a, b) {
          return new Date(a.meta.creationDate) - new Date(b.meta.creationDate);
        });
      }
      if (newValue == "A-Z") {
        var self = this;
        this.artefacts = this.artefacts.sort(function(a, b) {
          return a.title[self.lang].localeCompare(b.title[self.lang]);
        });
        this.collections = this.collections.sort(function(a, b) {
          return a.title[self.lang].localeCompare(b.title[self.lang]);
        });
        this.groups = this.groups.sort(function(a, b) {
          return a.title[self.lang].localeCompare(b.title[self.lang]);
        });
      }
      if (newValue == "Z-A") {
        var self = this;
        this.artefacts = this.artefacts.sort(function(a, b) {
          return b.title[self.lang].localeCompare(a.title[self.lang]);
        });
        this.collections = this.collections.sort(function(a, b) {
          return b.title[self.lang].localeCompare(a.title[self.lang]);
        });
        this.groups = this.groups.sort(function(a, b) {
          return b.title[self.lang].localeCompare(a.title[self.lang]);
        });
      }
      this.resetSearch();
      if (this.term != "") {
        this.generalSearch();
      }
      this.placeSearch();
    }
  }
};
</script>


<style src='@/../node_modules/slick-carousel/slick/slick.css'>

</style>


<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter,
.fade-leave-to {
  transition: opacity 0.2s ease;
  opacity: 0;
}
</style>


<style scoped >
.header_gray{
      background-color: #f5f5f5;
}
/* .card__media__background:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: none;
  opacity: 1;
} */
.curved {
  border-bottom-right-radius: 40% 10%;
  border-bottom-left-radius: 50% 10%;
}

#myImg:hover,
#myImg2:hover,
#myImg3:hover,
#myImg4:hover,
#myImg5:hover,
#myImg6:hover {
  opacity: 0.7;
}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 50; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  left: -27px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
  background-color: transparent;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}

.icon-circle {
  border-radius: 32px;
}

.pdfText {
  text-decoration: none;
  color: black !important;
  outline: none;
}

.pdfDate {
  font-size: 0.8em;
  color: grey;
}

.uploadedFilesText {
  color: grey;
}

.headerIcons {
  position: absolute;
  top: 6%;
  right: 4%;
}

.searchBar {
  /* padding-top:0px; */

  text-indent: 20px;
  padding-bottom: 15px;
  padding-left: 20px;
  padding-right: 20px;
}

.description p {
  text-align: justify;
}
html,
body {
  margin: 0;
  padding: 0;
}
* {
  box-sizing: border-box;
}
.slider {
  width: 50%;
  margin: 100px auto;
}

.group-title {
  color: white;
  font-size: 2.2em !important;
  top: 3%;
}

.group-subheading {
  position: absolute;

  font-size: 1.06em !important;
  top: 101%;
  left: 4%;
  color: white;
}

.collection-title {
  color: black;
  font-size: 2em !important;
  top: 3%;
}

.collection-subheading {
  position: absolute;

  font-size: 1.06em !important;
  top: 101%;
  left: 4%;
  color: black;
}

.headline {
  -webkit-text-stroke-width: 0.3px;
  -webkit-text-stroke-color: black;
}

.overlay-image {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100%;
}
</style>




<style scoped>
.headline-artefact {
  position: absolute;
  bottom: 3%;
  left: 3%;
  -webkit-text-stroke-width: 0.3px;
  -webkit-text-stroke-color: black;
}
.div1 {
  position: absolute;
  width: 67%;
  top: 4%;
}

.hrstl {
  color: #efefef;
  border-style: solid;
}

.spanstl {
  color: #b0b0b0;
}

.hrstl2 {
  color: #ddd;
  border-style: solid;
}

.div2 {
  position: absolute;
  width: 100%;
  top: 9%;
}

.hrstl3 {
  color: #efefef;
  border-style: solid;
}

.pstl {
  color: #b0b0b0;
}
.transitionFilters {
  -webkit-transition: width 2s; /* Safari */
  transition: width 2s;
}

.hrstl4 {
  color: #ddd;
  border-style: solid;
}

.div3 {
  position: absolute;
  width: 67%;
  top: 4%;
}

.group-div {
  width: 100%;
  top: 6% !important;
}

.exploreGroupInSlider {
  max-width: 100%;
}
</style>

<style src='@/../node_modules/slick-carousel/slick/slick.css'>

</style>

<style src='@/../node_modules/slick-carousel/slick/slick.css'>

</style>

<style src='@/../node_modules/vue-datetime/dist/vue-datetime.css'>

</style>






// WEBPACK FOOTER //
// src/components/Common/Explore.vue